const pointsApiBaseURL = process.env.POINTS_API_BASE_URL

const pointTokenConfig = token => {
  if (!token) {
    return {}
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      token,
    }
  }
}

/** 积分商城/抽奖请求配置：固定 brand=xp，并合并积分 token */
const mallRequestConfig = (token, extraHeaders = {}) => {
  const config = pointTokenConfig(token)
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      brand: 'xp',
      ...extraHeaders,
    },
  }
}

const addressApiBaseURL = process.env.NODE_ENV === 'development' ? 'https://www.test.storexppen.com' : 'https://www.xp-pen.com/store'
const storeApiBaseURL = process.env.NODE_ENV === 'development' ? 'https://www.newtest.xp-pen.com' : 'https://www.xp-pen.com'

export default ($axios) => {
  // $axios.setBaseURL('http://api.dev.xfans.xp-pen.com')//多域名配置
  return {
    getData: params => $axios.get('/api/get_index_data', {
      params
    }),
    postData: data => $axios.post('/index/workslist ', data),
    // ...your other api function
    applogin: data => $axios.post('/applogin/index', data), //总站sso

    xfansRegister: data => $axios.post('/sso.reg/index', data), //xfans注册
    slidelist: data => $axios.post('/index/slidelist', data), //首页获取轮播图
    workslistindex: data => $axios.post('/index/workslist_des', data), //首页作品列表
    workslist: data => $axios.post('/index/workslist', data), //作品列表
    galleryList: params => $axios.post('/works/index', params), //作品列表
    forumList: params => $axios.get('/forum/index', {
      params
    }), //帖子列表
    forumDetails: params => $axios.get('/forum/details', {
      params
    }), //帖子详情
    newList: params => $axios.get('/news/index', {
      params
    }), //资讯列表
    newsDetail: params => $axios.get('/news/newsdetails', {
      params
    }), //帖子详情
    activityList: params => $axios.get('/activity/index', {
      params,
    }), //活动列表
    courseList: params => $axios.get('/course/index', {
      params,
    }), //课程列表
    courseDetail: params => $axios.get('/course/video_detail_find', {
      params,
    }), //课程列表
    userInfo: data => $axios.post('/user.info/index', data), //个人中心
    userInfoDiscussion: data => $axios.post('/user.info/discussion', data), // 个人中心帖子
    professionHandle: data => $axios.post('/user.info/discussion', data), // 作品发布参数
    likeaction: data => $axios.post('/ajax/like', data), //点赞、取消点赞
    do_collect: data => $axios.post('/ajax/do_collect', data), //收藏、取消收藏
    releaseConfigure: data => $axios.post('/works/add_img', data), //发布中的标签和活动
    add_placard: data => $axios.post('/posts/add_placard', data), //发布帖子
    postsEditInfo: data => $axios.post('/posts/edit_info', data), //预填帖子编辑信息，请求只认 id
    postsEdit: data => $axios.post('/posts/edit', data), //提交帖子编辑
    worksUpload: data => $axios.post('/works/upload', data), //发布作品
    worksEditInfo: data => $axios.post('/works/edit_info', data), //预填作品编辑信息，请求只认 id
    worksEdit: data => $axios.post('/works/edit', data), //提交作品编辑
    commentLists: data => $axios.post('/comment/lists', data), //评论列表
    searchGallery: data => $axios.post('/search/gallery', data), //搜索作品列表
    searchCourse: data => $axios.post('/search/course', data), //搜索教程
    searchNews: data => $axios.post('/search/news', data), //搜索教程
    searchEvent: data => $axios.post('/search/event', data), //搜索活动
    searchDiscussion: data => $axios.post('/search/discussion', data), //搜索帖子
    searchAuthor: data => $axios.post('/search/author', data), //搜索用户
    searchAll: data => $axios.post('/search/all', data), //搜索全部
    searchSearch_select: data => $axios.post('/search/search_select', data), //搜索历史
    searchSearch_del: data => $axios.post('/search/search_del', data), //搜索清空
    authorIndex: data => $axios.post('/index/author', data), //作者榜
    worksDetails: params => $axios.get('/works/details', {
      params,
    }), //作品详情
    userlistIndex: params => $axios.get('/index/index_userlist', {
      params,
    }), //首页推荐用户
    formViaUpload: data => $axios.post('/works/uploadfile', data), //上传图片
    userinfoRecord: data => $axios.post('/user.info/settings', data), // 个人信息/钱包记录；完善资料奖励只认 data.profile_reward
    userinfoUpdate: data => $axios.post('/user.info/user_edit', data), // 个人信息修改
    userInfoCollected: data => $axios.post('/user.info/collected_gallery', data), //作品
    userInfoNews: data => $axios.post('/user.info/collected_news', data), //收藏咨询
    userInfoCollectDiscussion: data => $axios.post('/user.info/collected_discussion', data), //收藏帖子
    userInfoCourses: data => $axios.post('/user.info/collected_courses', data), //收藏教程
    userInfoCollectActivity: data => $axios.post('/user.info/collected_events', data), //收藏活动
    commentAdd: data => $axios.post('/comment/add', data), //添加评论
    doFollow: data => $axios.post('/ajax/do_follow', data), //添加关注
    unFollow: data => $axios.post('/ajax/un_follow', data), //取消关注
    userBlock: data => $axios.post('/user.block/block', data), //拉黑用户
    userBlockList: data => $axios.post('/user.block/blocklist', data), //黑名单列表
    userBlockCancel: data => $axios.post('/user.block/unblock', data), //移出黑名单，只传 target_user_id

    messageLike: data => $axios.post('/user.notice/index', data), //点赞消息
    followingMessages: data => $axios.post('/user.notice/following_messages', data), //关注消息
    messageMe: data => $axios.post('/user.notice/me', data), //@我消息
    messageReplies: data => $axios.post('/user.notice/my_replies', data), //回复消息
    complaintAdd: data => $axios.post('/feedback/complaint_add', data), //投诉
    userInfoUploadEdit: data => $axios.post('/user.info/background_edit', data), //上传背景图片
    userInfoUploadPassword: data => $axios.post('/user.info/security', data), //修改密码
    settingFeedback: data => $axios.post('/user.info/add_feedback', data), //意见反馈
    signFind: data => $axios.post('/user.info/sign_find', data), //签到查询
    sign: data => $axios.post('/user.info/sign', data), //签到操作
    userInfoActivityMessage: data => $axios.post('/user.notice/event_news_news', data), //活动消息
    userInfoSystemMessage: data => $axios.post('/user.notice/event_news', data), //系统消息
    userInfoPoints: data => $axios.post('/user.notice/pointMsg', data), //积分消息通知
    otherUserWorks: data => $axios.post('/index/user_index', data), //他人用户作品
    otherUserPost: data => $axios.post('/index/user_discussion', data), // 他人用户帖子
    worksDel: data => $axios.post('/works/del', data), //删除作品
    postsDel: data => $axios.post('/posts/del', data), //删除帖子
    commentDel: data => $axios.post('/comment/del', data), //删除评论
    parametricWork: data => $axios.post('/activity/works', data), //获取参赛的作品
    recommend_list: data => $axios.post('/course/recommend_list', data), //退出登录
    focusMe: data => $axios.post('/index/followers', data), // 关注我的
    myFocus: data => $axios.post('/index/following', data), //我关注的
    tagWorksList: data => $axios.post('/works/tag_works_list', data), //作品标签
    tagPostsList: data => $axios.post('/posts/tag_posts_list', data), //帖子标签
    searchTagWorksSearch: data => $axios.post('/works/tag_works_search', data), //作品标签搜索
    searchTagPostsSearch: data => $axios.post('/posts/tag_posts_search', data), //帖子标签搜索
    multiplefile_token: data => $axios.post('/index/multiplefile_token', data), //oss上传的凭证
    updateNotice: data => $axios.post('/user.notice/up_notice', data), //消息一键清空/单清空
    ossUrlFind: data => $axios.post('/index/oss_url_find', data), //获取oss真实地址
    addPostsVoteUser: data => $axios.post('/posts/add_posts_vote_user', data), //帖子详情选择投票
    userNotice: data => $axios.post('/works/user_list', data), //@消息
    uploadLog: data => $axios.post('/index/upload_log', data), //上传日志
    detailInt: data => $axios.post('/activity/detail_int', data), //活动ua
    captcha: data => $axios.post('/index/captcha_s', data),
    storeJumpUrl: data => $axios.post('/index/storeJumpUrl', data),
    worksTag: data => $axios.post('/works/works_tag', data), //作品分类
    worksListUser: data => $axios.post('/index/workslist_user', data), //首页新活动
    coursesListIndex: data => $axios.post('/index/courseList', data), //首页课程
    pointAuth: data => $axios.post('/point/auth', data), // 积分系统登录态校验
    pointLogin: data => $axios.post('/point/login', data), // 积分系统获取token
    pointsCenterDetail: (params, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/points/detail`, {
      params,
      ...pointTokenConfig(token),
    }), // 积分中心详情
    pointsCenterLogList: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/points/logList`, data, pointTokenConfig(token)), // 积分明细列表
    pointsMallRegions: () => $axios.get(`${pointsApiBaseURL}/mallPoints/api/common/regions`, mallRequestConfig()), // 积分商城国家/地区站点
    pointsMallList: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/goods/page`, data, mallRequestConfig(token)), // 积分商城列表
    pointsMallGoodsDetail: (id, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/goods/detail/${id}`, mallRequestConfig(token)), // 积分商城商品详情
    pointsMallGoodsMore: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/goods/more`, data, mallRequestConfig(token)), // 积分商城更多商品
    pointsMallExchange: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/goods/exchange`, data, mallRequestConfig(token)), // 积分商城兑换
    pointsMallExchangePreview: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/goods/exchange/preview`, data, mallRequestConfig(token)), // 积分商城兑换预览
    pointsMallOrderPage: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/order/exchange/page`, data, mallRequestConfig(token)), // 我的兑换列表
    pointsMallOrderDetail: (id, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/order/exchange/${id}`, mallRequestConfig(token)), // 我的兑换详情
    pointsMallConfirmReceipt: (id, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/order/exchange/confirm-receipt/${id}`, {}, mallRequestConfig(token)), // 确认收货
    pointsLotteryActivityList: (params, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/lottery/activity/list`, {
      params,
      ...mallRequestConfig(token),
    }), // 积分抽奖活动列表
    pointsLotteryActivityDetail: (id, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/lottery/activity/${id}`, mallRequestConfig(token)), // 积分抽奖活动详情
    pointsLotteryDraw: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/lottery/draw`, data, mallRequestConfig(token, {
      websiteId: '8920XP000103L31',
    })), // 积分抽奖
    pointsLotteryRecordPage: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/lottery/record/page`, data, mallRequestConfig(token)), // 我的抽奖中奖记录
    pointsLotteryAddressList: (params, token) => $axios.get(`${pointsApiBaseURL}/mallPoints/api/store/address/list`, {
      params,
      ...mallRequestConfig(token),
    }), // 积分系统地址簿
    pointsLotteryAddressAdd: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/store/address/add`, data, mallRequestConfig(token)), // 积分系统新增地址
    pointsLotteryAddressUpdate: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/store/address/update`, data, mallRequestConfig(token)), // 积分系统编辑地址
    pointsLotteryAddressDelete: (params, token) => $axios.delete(`${pointsApiBaseURL}/mallPoints/api/store/address/delete`, {
      params,
      ...mallRequestConfig(token),
    }), // 积分系统删除地址
    pointsLotteryPrizeClaim: (data, token) => $axios.post(`${pointsApiBaseURL}/mallPoints/api/lottery/address/submit`, data, mallRequestConfig(token)), // 实物奖品领取
    pointsAddressCountryList: params => $axios.get(`${addressApiBaseURL}/webapi.address/getCountryList?type=1`, {
      params,
    }), // 收货地址国家列表
    pointsAddressChildrenAreaList: params => $axios.get(`${addressApiBaseURL}/webapi.address/getChildrenAreaList`, {
      params,
    }), // 收货地址子级地区列表
    subscribe: data => $axios.post('/subscribe/index', data), // 邮件订阅
    siteLang: data => $axios.post('/language/siteLang', data), // 语种切换同步站点语言，body 只认 lang

    // 注册登录改版
    siteConfig: data => $axios.post('/index/siteConfig', data), // 获取站点配置
    sendCode: data => $axios.post('/passport/sendEmailCaptcha', data,{ is_main_site:true}), // 发送验证码
    passportRegister: (data, queryParams = {}) => $axios.post('/passport/reg', data, { is_main_site:true, params: queryParams}), // 注册
    passportLogin: (data, queryParams = {})  => $axios.post('/passport/login', data,{ is_main_site:true, params: queryParams}), // 登录
    getSceneId: data => $axios.post('/passport/encryptSceneId', data , { is_main_site:true}), // 获取加密场景ID
    checkEmail: data => $axios.post('/passport/checkEmail', data , { is_main_site:true}), // 检查邮箱是否存在
    sendDeletionCode: (data, queryParams = {}) => $axios.post('/deletion/sendDeletionCode', data, { is_main_site: true, params: queryParams }), // 注销发送验证码
    requestDeletion: (data, queryParams = {}) => $axios.post('/deletion/requestDeletion', data, { is_main_site: true, params: queryParams }), // 提交注销申请
    // body：email、captcha、is_agree 等；query：仅 params 里传的字段（如 jumpUrl、lang）
    sendPasswordFreeEmail: (data, queryParams = {}) =>$axios.post('/passport/sendPasswordFreeEmail', data, {is_main_site: true,params: queryParams}),
    thirdPartyLogin: (data, queryParams = {}) => $axios.post('/passport/loginByThirdParty', data , { is_main_site:true, params: queryParams}), // 第三方登录

    sendPasswordResetEmail: (data, queryParams = {}) => $axios.post('/passport/sendPasswordResetEmail', data , { is_main_site:true, params: queryParams}), // 发送重置密码邮件
    terminusLogin: data => $axios.post('/login/is_login', data ,{ is_main_site:true, params: { siteDomain: 'https://community.xp-pen.com/' }}), //SSO总站登录校验（lang 由拦截器注入）
    logout_xfans: data => $axios.post('/login/logout_xfans', data ,{ is_main_site:true}), //退出登录
    xfansLogin: data => $axios.post('/sso.login/index', data), //xfans登录
    logout: data => $axios.post('/sso.login/logout', data), //退出登录
    logout_syn: data => $axios.post('/sso.login/logout_syn', data), //退出登录
    getStoreBaseData: data => $axios.post(`${storeApiBaseURL}/api.index/baseData`, data, { withCredentials: true }), // 官方站商城站点列表（跨域带 cookie）
  }
}
